export default [
    "Bunker Trader", "Classification Society & Flag State representative", "Marine equipment & spare parts", "P & I", "Pilotage",
    "Port Agency", "Port Authority", "Port Operator", "Repairer & Shipbuilder", "Salvage & Rescue", "Ship Chandler", "Stevedoring Company",
    "Survey Company", "Towage"
];


// WEBPACK FOOTER //
// ./app/data/portActivities.js